import { render } from "./goodsListTable.vue?vue&type=template&id=7f2538e3&scoped=true"
import script from "./goodsListTable.vue?vue&type=script&lang=js"
export * from "./goodsListTable.vue?vue&type=script&lang=js"

import "./goodsListTable.vue?vue&type=style&index=0&id=7f2538e3&lang=scss&scoped=true"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2538e3"]])

export default __exports__